import { defineStore } from 'pinia';
import type { Promotions, Promotion } from '~/modules/GraphQL/types';

interface PromosState {
  promos: Promotions;
  promo: Promotion;
}

export const usePromosStore = defineStore('promos', {
  state: (): PromosState => ({
    promos: {
      total_count: 0,
      image_desktop_url: '',
      image_mobile_url: '',
      title: '',
      description: '',
      url_key: '',
      items: [],
      page_info: {
        page_size: 0,
        current_page: 0,
        total_pages: 0,
        __typename: 'SearchResultPageInfo',
      },
      __typename: 'Promotions',
    },
    promo: {
      image_desktop_url: null,
      image_mobile_url: null,
      description: null,
      is_enabled: true,
      title: '',
      label: '',
      url_key: '',
      items: [],
      __typename: 'Promotion',
    },
  }),
});
